export const AccountSettings = () => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M7.99999 7.99935C9.47332 7.99935 10.6667 6.80602 10.6667 5.33268C10.6667 3.85935 9.47332 2.66602 7.99999 2.66602C6.52666 2.66602 5.33332 3.85935 5.33332 5.33268C5.33332 6.80602 6.52666 7.99935 7.99999 7.99935ZM7.99999 9.33268C6.21999 9.33268 2.66666 10.226 2.66666 11.9993V13.3327H13.3333V11.9993C13.3333 10.226 9.77999 9.33268 7.99999 9.33268Z'
      fill='inherit'
    />
  </svg>
);
